import * as strategy from "@/service/strategyTemplate.js";
export default {
    namespaced: true,
    state: {
        rules: {
            template_name: [
                { required: true, message: "请输入任务名称", trigger: "blur" },
            ],
            template_describe: [
                { required: true, message: "请输入模板描述", trigger: "blur" },
            ],
        },
    },
    actions: {
        //查询树形格式模板列表
        getFormatTemplateTreeSto() {
            return strategy.getFormatTemplateTreeSer();
        },
        //添加策略模板
        addStrtegSto({ commit }, data) {
            return strategy.addStrtegSer(data);
        },
        // 获取策略模板列表
        getStrtegListSto({ commit }, datas) {
            return strategy.getStrtegListSer(datas);
        },
        //删除策略模板
        deleteStrtegSto({ commit }, datas) {
            return strategy.deleteStrtegSer(datas);
        },
        // 获取格式模板详情
        getStrtegSto({ commit }, datas) {
            return strategy.getStrtegSer(datas);
        },
        //修改格式模板
        editStrtegSto({ commit }, datas) {
            return strategy.editStrtegSer(datas);
        },
    },
};